module.exports = __webpack_public_path__ + "static/media/defaulticon.4129a037.svg";